export default __webpack_public_path__ + "static/media/4.444be598.jpg";